import React from "react";
import { Navigate, Route, Routes } from "react-router";
import { ErrorPage1 } from "./ErrorPage1";

export default function ErrorsPage() {
  return (
    <Routes>
      <Route path="/" element={<Navigate to="error-v1" replace />} />
      <Route path="error-v1" element={<ErrorPage1 />} />
    </Routes>
  );
}
